import {
  gsap
} from 'gsap'

import {
  ScrollTrigger
} from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

import TextPlugin from 'gsap/dist/TextPlugin.js'
gsap.registerPlugin(TextPlugin)

export default {
  inserted: (el, binding) => {

    let scrollTrigger = {
      trigger: el,
      start: 'top 80%',
      markers: false,
      toggleActions: 'play none none none'
    };

    if (binding.value && binding.value.to.scrollTrigger) {
      scrollTrigger = Object.assign(scrollTrigger, binding.value.to.scrollTrigger);
    }

    if (binding.value && binding.value.to) {

      let animation = binding.value.to
      animation.scrollTrigger = scrollTrigger

      if (!binding.value.to.stagger) {
        gsap.to(el, animation)
      } else {
        let query

        if (el.className) {
          query = "." + el.className.replace(/ /g, ".") + " " + binding.value.staggerEl
        } else {
          query = "." + el.className.replace(/ /g, ".") + " " + binding.value.staggerEl
          console.log('query:', query)
        }

        let children = document.querySelectorAll(query);
        gsap.to(children, animation)
      }
    }
  }
}